import styled from "styled-components";

export const ServicesContainer = styled.div`
    height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: antiquewhite;

    @media screen and (max-width: 1340px) {
        height: 960px;
    }
    @media screen and (max-width: 768px) {
        height: 1620px;
    }
`;

export const ServicesWrapper = styled.div`
    max-width: 1300px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    align-items: center;
    grid-gap: 16px;
    padding: 0 10px;

    @media screen and (max-width: 1340px) {
        grid-template-columns: 1fr 1fr;        
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 0 20px;
    }
`;

export const ServicesCard = styled.div`
    background: #fff2f2;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    max-height: 340px;
    height: 400px;
    padding: 15px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.5);
    transition: all 0.3s ease-in-out;

    &:hover{
        transform: rotate(2deg);
        transition: all 0.2s ease-in;
    }

    @media screen and (max-width: 420px) {
        height: 320px;
    }
`;

export const ServicesH1 = styled.h1`
    font-size: 48px;
    color: #442E1E;
    margin-bottom: 64px;

    @media screen and (max-width: 480px) {
        font-size: 32px;
    }
`;

export const ServicesH2 = styled.h2`
    font-size: 1.1rem;
    margin-bottom: 10px;
`;

export const ServicesP = styled.div`
    font-size: 1rem;
    text-align: center;
`;

export const ServicesIcon = styled.img`
    height: 400px;
    max-height: 230px;    
    width: auto;
    margin-bottom: 10px;
    margin: auto;

    @media screen and (max-width: 420px) {
        height: 310px;
        max-height: 180px;  
    }
`;

export const TopLine = styled.p`
    color: #2BBAE0;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`;